import request from '@/utils/request'


//修改密码
export function userEditPassword(data) {
  return request({
    url: "/AdminAccount/AdminUserUpPasswd",
    method: "post",
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js